import AuthService from "../../../Services/authService";

export default class ReportTemplateParameters
{
	constructor() 
	{
		this.initialize();
	}

	initialize()
	{
		let loggedInUser=AuthService.getInstance().GetLoggedInUser();
		
		this.Name="";
		this.OfficeParameterType="";
		this.ClientParameterType="";
		this.ProjectParameterType="";
		this.selectedFile=null;
		this.UserId=(loggedInUser===undefined)?0:loggedInUser.userId
	}
}